import type { ChipTemplate } from '@/components/ui/template-chips';

// Preset reasons the admin can pick when rejecting an appeal. Kept here
// (not under creators/) because the eslint no-restricted-imports rule
// blocks cross-module imports — each module owns its own preset list.
export const ADMIN_REJECT_APPEAL_TEMPLATES: ReadonlyArray<ChipTemplate> = [
  {
    id: 'no_fit',
    label: 'No encaja',
    text: 'Tras revisar el perfil mantengo el rechazo: no cumple criterios de Debook.',
  },
  {
    id: 'wrong_category',
    label: 'Categoría incorrecta',
    text: 'No corresponde a la categoría solicitada — revisa el perfil y vuelve a proponerlo con la categoría correcta si aplica.',
  },
  {
    id: 'insufficient_content',
    label: 'Contenido insuficiente',
    text: 'Sin contenido suficiente para validar — el perfil no muestra evidencia clara de los requisitos.',
  },
];
